export type PaymentMethodsImageBased =
  | 'amex'
  | 'diners'
  | 'discover'
  | 'klarna_sofort'
  | 'mastercard'
  | 'paydirekt'
  | 'paypal'
  | 'ideal'
  | 'visa'
  | 'mastercard_clicktopay'
  | 'visa_clicktopay'
  | 'clicktopay'
  | 'wero';

export type PaymentMethodsTextBased = 'bank_debit' | 'flexikonto' | 'installments' | 'invoice';

// The order of the entries in the array determine the order in which the payment methods are presented to the user.
export type PaymentMethodsConfig = {
  paymentMethods: {
    imageBased: PaymentMethodsImageBased[];
    textBased: PaymentMethodsTextBased[];
  };
};

export const paymentMethodsConfig: PaymentMethodsConfig = {
  paymentMethods: {
    imageBased: [
      'paypal',
      'paydirekt',
      'mastercard',
      'visa',
      'klarna_sofort',
      'diners',
      'discover',
    ],
    textBased: ['invoice', 'flexikonto'],
  },
};
